<template>
  <v-tooltip
    :disabled="!calculatedTooltip"
    top>
    <template #activator="{on}">
      <nx-chip
        v-bind="$attrs"
        v-on="on"
        @click.capture.stop="handleAction"
        :url="url"
        :translation-variables="translationVariables"
      />
    </template>
    <strong v-html="calculatedTooltip"></strong>
  </v-tooltip>
</template>
<script>
import NxChip from '@/components/chips/Chip';
import { copyToClipboard } from '@/utils';

export default {
  name: 'ListItemChip',
  components: { NxChip },
  props: {
    action: {
      type: Object,
    },
    url: {
      type: String,
    },
    tooltip: {
      type: String,
    },
    translationVariables: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    calculatedTooltip() {
      return this.$te(`message.${this.tooltip}`) ? this.$tc(`message.${this.tooltip}`, 1, this.translationVariables) : this.tooltip;
    },
  },
  methods: {
    async handleAction(event) {
      event.stopPropagation();
      event.preventDefault();

      if (this.url) {
        this.$router.push(this.url);
        return;
      }

      if (!this.action) {
        return;
      }

      if (this.action.name === 'clipboard-copy') {
        await copyToClipboard(this.action.value);
        this.toast.notify('message.list.actions.clipboardCopy');
      }

      if (this.action.name === 'add-filter-search'
        || this.action.name === 'add-filter-array-search') {
        this.$emit('input:add-filter', { [this.action.field]: this.action.value });
      }

      if (this.action.name === 'set-filter-search'
        || this.action.name === 'set-filter-array-search') {
        this.$emit('input:set-filter', { [this.action.field]: this.action.value });
      }
    },
  },
};
</script>
